import SocialLinks from './SocialLinks'

function TopBar({ isPortfolio }) {
  return (
    <header className="topbar">
      <SocialLinks />
      {isPortfolio ? (
        <a className="topbar-link" href="/">
          Playground
        </a>
      ) : (
        <a className="topbar-link" href="/portfolio">
          Portfolio
        </a>
      )}
    </header>
  )
}

export default TopBar
